import { render, staticRenderFns } from "./CardListMealPlans.vue?vue&type=template&id=e3ffaae2&scoped=true"
import script from "./CardListMealPlans.vue?vue&type=script&lang=js"
export * from "./CardListMealPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ffaae2",
  null
  
)

export default component.exports